var _path, _path2, _path3, _circle, _circle2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxCategories({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1H18.2314C20.9929 1 23.2314 3.23858 23.2314 6V23.2314H6C3.23858 23.2314 1 20.9929 1 18.2314V6C1 3.23858 3.23858 1 6 1Z",
    fill: "#CCE5FF",
    stroke: "#28345A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1055 1H48.3369C51.0983 1 53.3369 3.23858 53.3369 6V18.2314C53.3369 20.9929 51.0983 23.2314 48.3369 23.2314H31.1055V6L31.1123 5.74316C31.246 3.10111 33.4302 1 36.1055 1Z",
    fill: "#CCE5FF",
    stroke: "#28345A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 31.1057H23.2314V48.3372C23.2314 51.0986 20.9929 53.3372 18.2314 53.3372H6C3.23858 53.3372 1 51.0986 1 48.3372V36.1057C1 33.3443 3.23858 31.1057 6 31.1057Z",
    fill: "#CCE5FF",
    stroke: "#28345A",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 39,
    r: 8,
    fill: "#CCE5FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7528,
    cy: 39.2843,
    r: 8.17858,
    stroke: "#28345A",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.3711,
    y: 45.6858,
    width: 2.20286,
    height: 13.0527,
    rx: 1.10143,
    transform: "rotate(-43.8303 45.3711 45.6858)",
    fill: "#28345A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxCategories);
export default __webpack_public_path__ + "static/media/taxCategories.c65b19ffa05f8fd70ff167f9f28c88e0.svg";
export { ForwardRef as ReactComponent };